module.exports = __webpack_public_path__ + "img/00023.d3b34340.webp";